import { Component, Input, OnInit } from '@angular/core';
import { ModalP2pEditService } from '../../services/modal-p2p-edit/modal-p2p-edit.service';
import { PeerToPeerManageService } from '../../services/peer-to-peer-manage/peer-to-peer-manage.service';
import { Store } from '@ngrx/store';
import { updateP2P } from '../../features/p2p.actions';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCurrencyDirective } from 'ngx-currency';

@Component({
  standalone:true,
  selector: 'app-p2p-edit-modal',
  templateUrl: './p2p-edit-modal.component.html',
  styleUrls: ['./p2p-edit-modal.component.scss'],
  imports:[CommonModule,FormsModule,ReactiveFormsModule, NgxCurrencyDirective]
})
export class P2pEditModalComponent implements OnInit {
  
  @Input () data
  
  public P2PItemId = null;

  public displayNameInputValue = '';
  public createdByNameInputValue: string = '';
  public goalInputValue = null;

  public isDisplayNameLabelActive = false;
  public isCreatedByNameLabelActive: boolean = false;
  public isGoalLabelActive = false;
  
  public showDisplayNameError = false;
  public showCreatedByNameError: boolean = false;
  public showGoalError = false;

  public isEditActive = false;

  constructor(
    public peerToPeerManageService: PeerToPeerManageService,
    public modalP2pEditService: ModalP2pEditService,
    private store: Store,
    ) { }

  ngOnInit(): void {
    this.P2PItemId = this.data.id;
    
    this.displayNameInputValue = this.data.displayName;
    this.createdByNameInputValue = this.data.createdByName || this.data.userInfo.name;
    this.goalInputValue = this.data.goal;

    this.isDisplayNameLabelActive = !! this.displayNameInputValue;
    this.isCreatedByNameLabelActive = !! this.createdByNameInputValue;
  }

  onInputFocus() {
    this.showDisplayNameError = false;
    this.showCreatedByNameError = false;
    this.showGoalError = false;
  }
  
  update() {
    if (!this.validate()) {
      return;
    }

    const params = {
      id: this.P2PItemId,
      displayName: this.displayNameInputValue,
      createdByName: this.createdByNameInputValue,
      goal: this.goalInputValue
    }

    this.store.dispatch({
      type: updateP2P.type,
      payload: params
    });

    this.close();
  }

  validate() {
    if(this.displayNameInputValue === '') {
      this.showDisplayNameError = true;
      return false;
    } else 
      this.showDisplayNameError = false;

    if(this.createdByNameInputValue === '') {
      this.showCreatedByNameError = true;
      return false;
    } else 
      this.showCreatedByNameError = false;    

    if(this.goalInputValue === null || this.goalInputValue === 0 || this.goalInputValue === '$') {
      this.showGoalError = true;
      return false;
    } else 
      this.showGoalError = false;

    return true;
  }

  close() {
    this.modalP2pEditService.close();
  }
}
